import HStack from "shared/components/layout/stack/HStack";
import { mediaQueries } from "shared/config/breakpoints";
import styled from "styled-components";

export const StyledFooter = styled.footer`
    width: 100%;
`;

export const StyledWrapper = styled(HStack)`
    align-items: flex-start;
    justify-content: flex-end;
    padding: 32px 64px;
    gap: 4px;
    height: 5rem;

    ${mediaQueries.small} {
        flex-direction: column;
        padding: 32px 24px;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: auto;
        gap: 0px;
    }
`;
